module.exports = __webpack_public_path__ + "static/img/stay-option-icon-hanger.a1c925b7.svg";